import { ADD_LATEST_PRODUCT } from './constants';

export const addLatestProduct = product => dispatch => {
    dispatch({
        type: ADD_LATEST_PRODUCT,
        product,
    });
};
